import React ,{ Component } from "react";
import "./administrador.css";
import { Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from 'reactstrap';
import Utils from "../../Utils";
import { Cargando } from '../estados/Cargando';

export class Beneficios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalBen: props.modalBen,
            beneficios: [],
            estado: false,
            rol: props.rol
        };

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.getgetBeneficios();
    }

    toggle = () => {
        this.props.modalBen();
    }

    async getgetBeneficios() {
        this.setState({ estado: false })
        await Utils.getBeneficios()
            .then(data => {
                if (data !== undefined) {
                    this.setState({ beneficios: data, estado: true })
                    
                }
            });
    }

    async sendForm() {
        const formData = new FormData(this.inputRef.current);

        let json = "[";
        let index = 0;
        for (const [key, value] of formData.entries()) {
            if (index === 0) json += "{";
            json += `"${key}": "${value}"`
            index++;
            if (index === 8) {
                json += "},";
                index = 0;
            }
            else json += ",";
        }
        json = json.slice(0, -1) + "]";
        if (this.state.rol === "A")
            await Utils.setBeneficios(json);
    }

    cambioHandler(benef, nuevoValor) {
        const nuevosBeneficios = this.state.beneficios.map((input) => {
            if (input.id === benef.id) {
                switch (nuevoValor.name) {
                    case "nombre": input.nombre = nuevoValor.value;
                        break;
                    case "informacion": input.informacion = nuevoValor.value;
                        break;
                    case "valor5": input.valor5 = nuevoValor.value;
                        break;
                    case "valor4": input.valor4 = nuevoValor.value;
                        break;
                    case "valor3": input.valor3 = nuevoValor.value;
                        break;
                    case "valor2": input.valor2 = nuevoValor.value;
                        break;
                    case "valor1": input.valor1 = nuevoValor.value;
                        break;
                    default:
                        break;
                }
            }
            return input;
        });
        if (this.state.rol === "A")
            this.setState({ beneficios: nuevosBeneficios });
    }

    nuevoBeneficio() {
        const nuevosBeneficios = this.state.beneficios;
        nuevosBeneficios.push({ id: 0, nombre: "", informacion: "", valor5: "", valor4: "", valor3: "", valor2: "", valor1: "" });
        this.setState({ beneficios: nuevosBeneficios });
    }

    eliminarBeneficio(id) {
        const nuevosBeneficios = this.state.beneficios.map((input) => {
            if (input.id !== id) return input;
        });

        const filtroBeneficios = nuevosBeneficios.filter(elemento => elemento !== undefined);

        this.setState({ beneficios: filtroBeneficios });
    }

    render() {
        return (
            <>
                {!this.state.estado ?? <div><Cargando></Cargando></div>}
                <ModalHeader toggle={() => this.toggle()}>Valores Beneficios</ModalHeader>
                <ModalBody>
                    <form id="beneForm" ref={this.inputRef}>
                        <table>
                            <thead>
                                <tr>
                                    <td style={{ visibility: "hidden" }}></td>
                                    <td style={{ visibility: "hidden" }}></td>
                                    <th scope="col">Nivel 5 </th>
                                    <th scope="col">Nivel 4</th>
                                    <th scope="col">Nivel 3</th>
                                    <th scope="col">Nivel 2</th>
                                    <th scope="col">Nivel 1</th>
                                </tr>
                            </thead>
                            <tbody className="beneficiosEdit">
                                {this.state.beneficios.map((beneficio) => (
                                    <tr>
                                        <td>
                                            <Input type="hidden" name="id" value={beneficio.id}/>
                                            <FormGroup>
                                                <Label for="nombreBeneficio">Nombre</Label>
                                                <Input id="nombreBeneficio" name="nombre" placeholder="Nombre beneficio" type="text" value={beneficio.nombre} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="informacionBeneficio">Información</Label>
                                                <Input id="informacionBeneficio" name="informacion" placeholder="Informacion beneficio" type="text" value={beneficio.informacion} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="valor5Beneficio"></Label>
                                                <Input id="valor5Beneficio" name="valor5" type="text" value={beneficio.valor5} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="valor4Beneficio"></Label>
                                                <Input id="valor4Beneficio" name="valor4" type="text" value={beneficio.valor4} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="valor3Beneficio"></Label>
                                                <Input id="valor3Beneficio" name="valor3" type="text" value={beneficio.valor3} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="valor2Beneficio"></Label>
                                                <Input id="valor2Beneficio" name="valor2" type="text" value={beneficio.valor2} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <Label for="valor1Beneficio"></Label>
                                                <Input id="valor1Beneficio" name="valor1" type="text" value={beneficio.valor1} onChange={(e) => this.cambioHandler(beneficio, e.target)} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            {this.state.rol === "A" ?
                                                <Button type="button" color="default" onClick={() => this.eliminarBeneficio(beneficio.id)}>Eliminar</Button> : null
                                            }
                                        </td>
                                    </tr>
                                ))}
                                {this.state.rol === "A" ?
                                    <tr>
                                        <td>
                                            <Button type="button" color="success" onClick={() => this.nuevoBeneficio()}>+ Nuevo</Button>
                                        </td>
                                    </tr> : null
                                }
                            </tbody>
                        </table>
                    </form>
                </ModalBody>
                <ModalFooter>
                    {this.state.rol === "A" ?
                        <Button color="primary" onClick={() => this.sendForm()}>
                            Guardar
                        </Button> : null
                    }
                    {' '}
                    <Button color="secondary" onClick={() => this.toggle()}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </>
        );
    }
}
